module.exports = __webpack_public_path__ + "img/img_huodong@2x.e44bb0e8.png";